const Experiences =()=>{
return (<section className="work-section py-3">
<h3 className="text-uppercase resume-section-heading mb-4">
    Work Experience
</h3>
<div className="item">
    <div className="item-heading row align-items-center mb-2">
        <h4 className="item-title col-12 col-md-6 col-lg-7 mb-2 mb-md-0">
        🦊 Foxtrot Dash Inc.
        </h4>
        <div className="item-meta col-12 col-md-6 col-lg-5 text-muted text-left text-md-right">
            Full-Stack Software Engineer | September 2022 - December 2022
        </div>
    </div>
    <div className="item-content">
        <p>
        Building frontend and backend components for Foxtrot Dash using React.js/Next.js,  
        React Hooks, Java, PostgreSQL, Spring Boot, version control using Git and Github, 
        Managing Deployments and builds using Jenkins.
        The app is hosted at{" "}<a href="https://foxtrotdash.com">
        https://foxtrotdash.com
            </a>
        </p>
    </div>
</div>
<div className="item">
    <div className="item-heading row align-items-center mb-2">
        <h4 className="item-title col-12 col-md-6 col-lg-7 mb-2 mb-md-0">
            Thamani Business Doctors
        </h4>
        <div className="item-meta col-12 col-md-6 col-lg-5 text-muted text-left text-md-right">
            SME Triage Web App and Admin Portal | May 2022 - June 2022
        </div>
    </div>
    <div className="item-content">
        <p>
        Lead Developer on the SME Triage Web Application as well as the admin Dashboard built 
        using ReactJS 18+ and Bootstrap 5. Worked on the Landing page design and implementation 
        to integrate it to the existing Website.Lead Developer on the SME Triage Web Application 
        as well as the admin Dashboard built using ReactJS 18+ and Bootstrap 5. 
        Worked on the Landing page design and implementation to integrate it to the existing Website. 
        The app is hosted at{" "}<a href="https://sme-triage.businessdoctors.org">
        https://sme-triage.businessdoctors.org
            </a>
        </p>
    </div>
</div>
<div className="item">
    <div className="item-heading row align-items-center mb-2">
        <h4 className="item-title col-12 col-md-6 col-lg-7 mb-2 mb-md-0">
            CoolPam Water Systems
        </h4>
        <div className="item-meta col-12 col-md-6 col-lg-5 text-muted text-left text-md-right">
            Admin Portal | November 2021 - March 2022
        </div>
    </div>
    <div className="item-content">
        <p>
            CoolPam Water Systems is a water distribution company based
            in Nairobi, Kenya. I worked on the Admin portal that I built
            using React.js and TypeScript using FIrebase as the
            back-end. The Web Application is hosted at{" "}                        <a href="https://maji.coolpamsystems.com">
                https://maji.coolpamsystems.com
            </a>
            . This project allowed me to lead other development teams
            such as the mobile development team into steering the app
            into production with the desired results.
        </p>
    </div>
</div>
<div className="item">
    <div className="item-heading row align-items-center mb-2">
        <h4 className="item-title col-12 col-md-6 col-lg-7 mb-2 mb-md-0">
            Liquid Foods
        </h4>
        <div className="item-meta col-12 col-md-6 col-lg-5 text-muted text-left text-md-right">
            Admin Portal | August 2020 - December 2021
        </div>
    </div>
    <div className="item-content">
        <p>
            Liquid Foods is a food ordering company based in Juja,
            Kenya, that allows people to order and have foods delivered
            to their doorstep. I built their admin Portal using PHP, JS
            and Fireabse. The Web Application is hosted at{" "}                        <a href="https://liquid.co.ke">https://liquid.co.ke</a>
            This project allowed me to lead other development teams such
            as the mobile development team into steering the app into
            production with the desired results.
        </p>
    </div>
</div>
<div className="item mb-3">
    <div className="item-heading row align-items-center mb-2">
        <h4 className="item-title col-12 col-md-6 col-lg-7 mb-2 mb-md-0">
            Health IT - University of Narobi Enterprise Services (UNES)
        </h4>
        <div className="item-meta col-12 col-md-6 col-lg-5 text-muted text-left text-md-right">
            Kenya EMR Development | 2021 March
        </div>
    </div>
    <div className="item-content">
        <p>
            Kenya EMR Module Development and Testing during pre-pilot
            bug fixing and and testing. Helped in fixing bugs and UI
            issues using Java, Javascript and JQuery to do validations
            for forms as well as fix UI display issues.
        </p>
    </div>
</div>
<div className="item mb-3">
    <div className="item-heading row align-items-center mb-2">
        <h4 className="item-title col-12 col-md-6 col-lg-7 mb-2 mb-md-0">
            Health IT - University of Narobi Enterprise Services (UNES)
        </h4>
        <div className="item-meta col-12 col-md-6 col-lg-5 text-muted text-left text-md-right">
            Imaging System | 2021 January - September
        </div>
    </div>
    <div className="item-content">
        <p>
            Developed Imaging System to be used internally and
            externally by the Vihiga County Referal Hospital to be used
            for uploading and downloading images replacing the need of
            Compact Disks. This role allowed me to lead other
            development teams such as the mobile development team into
            developing a Diabetes and Hypertension Management
            Application that is still in Beta. Helped in fixing issues
            with KenyaEMR at the facility as well as neighbouring
            facilities in Vihiga County, as well as deployment of the
            KenyaEMR+ instance, fixing issues that occured on the system
            as well as provided user support at the facility. Assisted
            in resolving issues with the network at the facility that{" "}                        included issued with DHCP server as well as managing app
            deployments at the facility.
        </p>
    </div>
</div>
<div className="item mb-3">
    <div className="item-heading row align-items-center mb-2">
        <h4 className="item-title col-12 col-md-6 col-lg-8 mb-2 mb-md-0">
            Health IT - University of Narobi Enterprise Services (UNES)
            Internship
        </h4>
        <div className="item-meta col-12 col-md-6 col-lg-4 text-muted text-left text-md-right">
            Kisumu County Ministry of Health. | 2019 June - August
        </div>
    </div>
    <div className="item-content">
        <p>
            Developed Web Applications to be used internally by the
            Kisumu Health Management Information Systems Department for
            Data Visualization and Annual Work Plan, built using
            Bootstrap 4, Javascript and JQuery. Backed using PHP as the
            backend.
        </p>
    </div>
</div>
{/*//item*/}
<div className="item mb-3">
    <div className="item-heading row align-items-center mb-2">
        <h4 className="item-title col-12 col-md-6 col-lg-8 mb-2 mb-md-0">
            HI4Kenya
        </h4>
        <div className="item-meta col-12 col-md-6 col-lg-4 text-muted text-left text-md-right">
            DHIS2 Apps Developer | 2018
        </div>
    </div>
    <div className="item-content">
        <p>
            Worked on Metadata Dictionary Application for DHIS2 instance
            using React.js. The repository can be found at{" "}
            <a href="https://github.com/kanji-karanja/MetaDataDHIS2">
                https://github.com/karimkkanji/MetaDataDHIS2
            </a>
            and the documentation{" "}
            <a href="https://metadatadhis2.readthedocs.io/en/latest/">
                https://metadatadhis2.readthedocs.io/en/latest/
            </a>
        </p>
    </div>
</div>
<div className="item mb-3">
    <div className="item-heading row align-items-center mb-2">
        <h4 className="item-title col-12 col-md-6 col-lg-8 mb-2 mb-md-0">
            Cryosoft Corporation.
        </h4>
        <div className="item-meta col-12 col-md-6 col-lg-4 text-muted text-left text-md-right">
            Software Development and Management| 2016 August to date
        </div>
    </div>
    <div className="item-content">
        <p>
            Developed Web Applications and Android Applications that{" "}                        support SMEs in doing their businesses allowing them to have
            an online presence as well as manage their businesses.
        </p>
    </div>
</div>
{/*//item*/}
</section>);
}

export default Experiences;